import React from 'react';

import ActivityMyTokens from '@/assets/icons/activity-mytokens.svg';
import UsdcIcon from '@/assets/icons/usdc-blue.svg';
import { Image } from '@/components/shared/Image';
import { T_SwapDirection } from '@/hooks/PoolsToken/usePoolsTokenSwap';

import type { T_Pool } from '@/ts/types/T_Pool';

interface I_TokenIcons {
  inputIcon: React.ReactNode;
  inputLabel: string;
  outputIcon: React.ReactNode;
  outputLabel: string;
}

export function getTokenIcons(
  pool: T_Pool,
  swapDirection: T_SwapDirection
): I_TokenIcons {
  const inputIcon =
    swapDirection === 'usdc-to-token' ? (
      <UsdcIcon className="w-6 h-6" />
    ) : pool.banner?.url ? (
      <div className="relative w-6 h-6">
        <Image
          src={pool.banner.url}
          alt={pool.tokenSymbol}
          className="w-6 h-6 rounded-full object-cover"
        />
      </div>
    ) : (
      <div className="w-6 h-6 rounded-full bg-primary flex items-center justify-center">
        <ActivityMyTokens className="w-4 h-4" />
      </div>
    );

  const inputLabel =
    swapDirection === 'usdc-to-token' ? 'USDC' : pool.tokenSymbol;

  const outputIcon =
    swapDirection === 'usdc-to-token' ? (
      pool.banner?.url ? (
        <div className="flex relative w-6 h-6">
          <Image
            src={pool.banner.url}
            alt={pool.tokenSymbol}
            className=" w-full h-full rounded-full object-cover"
          />
        </div>
      ) : (
        <div className="w-6 h-6 rounded-full bg-primary flex items-center justify-center">
          <ActivityMyTokens className="w-4 h-4" />
        </div>
      )
    ) : (
      <UsdcIcon className="w-6 h-6" />
    );

  const outputLabel =
    swapDirection === 'usdc-to-token' ? pool.tokenSymbol : 'USDC';

  return {
    inputIcon,
    inputLabel,
    outputIcon,
    outputLabel
  };
}
